import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { LogoVariant } from '../../../types';

/**
 * The FR8BOT logo, drawn inline: `full` is the wordmark (169×20), `small` the mark alone (30×20).
 * The lime part is fixed, the rest of the wordmark takes the text colour. Without `width` /
 * `height` the host keeps its natural size, or whatever the consumer's CSS sets.
 */
@Component({
  selector: 'fr8bot-ui-logo',
  host: {
    '[class.fr8bot-logo--small]': "variant() === 'small'",
    '[style.width.px]': 'width()',
    '[style.height.px]': 'height()',
  },
  templateUrl: './logo.component.html',
  styleUrl: './logo.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoUIComponent {
  readonly variant = input<LogoVariant>('full');
  readonly width = input<number>();
  readonly height = input<number>();
}
